var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "invoice-review" },
    [
      _c(
        "header",
        { staticClass: "review-heading" },
        [
          _c("div", [_c("h1", [_vm._v(_vm._s(_vm.t("title")))])]),
          _c("el-progress", {
            staticClass: "review-progress",
            attrs: {
              percentage: _vm.percentage,
              "stroke-width": 7,
              "show-text": false,
            },
          }),
          _c(
            "el-button",
            {
              attrs: { icon: "el-icon-refresh", loading: _vm.loading },
              on: { click: _vm.loadList },
            },
            [_vm._v(_vm._s(_vm.t("refresh")))]
          ),
        ],
        1
      ),
      _c(
        "el-form",
        {
          staticClass: "review-filters",
          attrs: { inline: true, size: "small" },
          nativeOn: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.search.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.t("week") } },
            [
              _c("el-date-picker", {
                attrs: {
                  type: "week",
                  format: "yyyy-WW",
                  clearable: false,
                  "picker-options": { firstDayOfWeek: 1 },
                },
                on: { change: _vm.changeWeek },
                model: {
                  value: _vm.weekDate,
                  callback: function ($$v) {
                    _vm.weekDate = $$v
                  },
                  expression: "weekDate",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.t("client") } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    filterable: "",
                    clearable: "",
                    placeholder: _vm.t("allClients"),
                  },
                  model: {
                    value: _vm.filters.clientCode,
                    callback: function ($$v) {
                      _vm.$set(_vm.filters, "clientCode", $$v)
                    },
                    expression: "filters.clientCode",
                  },
                },
                _vm._l(_vm.clients, function (client) {
                  return _c("el-option", {
                    key: client.value,
                    attrs: {
                      label: client.label + " · " + client.value,
                      value: client.value,
                    },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "Invoice" } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: _vm.t("invoiceNo") },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.search.apply(null, arguments)
                  },
                },
                model: {
                  value: _vm.filters.invoiceId,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.filters,
                      "invoiceId",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "filters.invoiceId",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.t("source") } },
            [
              _c(
                "el-select",
                {
                  attrs: { clearable: "", placeholder: _vm.t("allSources") },
                  model: {
                    value: _vm.filters.source,
                    callback: function ($$v) {
                      _vm.$set(_vm.filters, "source", $$v)
                    },
                    expression: "filters.source",
                  },
                },
                [
                  _c("el-option", {
                    attrs: { label: "Manual", value: "MANUAL" },
                  }),
                  _c("el-option", {
                    attrs: { label: "Ticket", value: "TICKET" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.t("charge") } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    "allow-create": "",
                    "default-first-option": "",
                    placeholder: _vm.t("allCharges"),
                  },
                  model: {
                    value: _vm.filters.categoryCode,
                    callback: function ($$v) {
                      _vm.$set(_vm.filters, "categoryCode", $$v)
                    },
                    expression: "filters.categoryCode",
                  },
                },
                _vm._l(_vm.categories, function (category) {
                  return _c("el-option", {
                    key: category.value,
                    attrs: { label: category.label, value: category.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.t("status") } },
            [
              _c(
                "el-select",
                {
                  attrs: { clearable: "", placeholder: _vm.t("allStatuses") },
                  model: {
                    value: _vm.filters.reviewed,
                    callback: function ($$v) {
                      _vm.$set(_vm.filters, "reviewed", $$v)
                    },
                    expression: "filters.reviewed",
                  },
                },
                [
                  _c("el-option", {
                    attrs: { label: _vm.t("unreviewed"), value: "false" },
                  }),
                  _c("el-option", {
                    attrs: { label: _vm.t("reviewed"), value: "true" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { staticClass: "filter-actions" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", icon: "el-icon-search" },
                  on: { click: _vm.search },
                },
                [_vm._v(_vm._s(_vm.t("search")))]
              ),
              _c("el-button", { on: { click: _vm.reset } }, [
                _vm._v(_vm._s(_vm.t("reset"))),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm.error
        ? _c("el-alert", {
            attrs: {
              title: _vm.error,
              type: "error",
              closable: false,
              "show-icon": "",
            },
          })
        : _vm._e(),
      _vm.scopeFiltered
        ? _c("el-alert", {
            staticClass: "scope-note",
            attrs: {
              title: _vm.t("filteredScope"),
              type: "info",
              closable: false,
              "show-icon": "",
            },
          })
        : _vm._e(),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "invoice-groups",
        },
        [
          !_vm.loading && !_vm.groups.length
            ? _c("div", { staticClass: "empty-state" }, [
                _c("i", { staticClass: "el-icon-document-checked" }),
                _c("h3", [_vm._v(_vm._s(_vm.t("empty")))]),
                _c("p", [_vm._v(_vm._s(_vm.t("emptyHint")))]),
              ])
            : _vm._e(),
          _vm._l(_vm.groups, function (group) {
            return _c(
              "article",
              { key: group.invoiceId, staticClass: "invoice-group" },
              [
                _c(
                  "header",
                  { staticClass: "invoice-header" },
                  [
                    _c("el-button", {
                      attrs: {
                        type: "text",
                        icon: group.expanded
                          ? "el-icon-arrow-down"
                          : "el-icon-arrow-right",
                        "aria-label": _vm.t("toggle"),
                      },
                      on: {
                        click: function ($event) {
                          group.expanded = !group.expanded
                        },
                      },
                    }),
                    _c("div", { staticClass: "invoice-identity" }, [
                      _c("strong", [_vm._v(_vm._s(group.invoiceId))]),
                      _c("span", [
                        _vm._v(
                          _vm._s(group.companyName || group.clientCode) +
                            " · " +
                            _vm._s(group.clientCode)
                        ),
                      ]),
                    ]),
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type: group.reviewed ? "success" : "warning",
                          size: "small",
                          effect: "light",
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.t(group.reviewed ? "reviewed" : "unreviewed")
                          )
                        ),
                      ]
                    ),
                    _c("div", { staticClass: "invoice-subtotal" }, [
                      _c("strong", [
                        _vm._v("$" + _vm._s(_vm.money(group.manualSubtotal))),
                      ]),
                    ]),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", icon: "el-icon-time" },
                        on: {
                          click: function ($event) {
                            return _vm.openHistory(group)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.t("history")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          size: "small",
                          type: group.reviewed ? "default" : "primary",
                          loading:
                            _vm.saving &&
                            _vm.reviewSavingId === group.invoiceId,
                          disabled:
                            _vm.saving || group.reviewed || group.loadingRows,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.markReviewed(group)
                          },
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.t(group.reviewed ? "reviewed" : "markReviewed")
                          )
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: group.expanded,
                        expression: "group.expanded",
                      },
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: group.loadingRows,
                        expression: "group.loadingRows",
                      },
                    ],
                    staticClass: "invoice-body",
                  },
                  [
                    group.error
                      ? _c("el-alert", {
                          attrs: {
                            title: group.error,
                            type: "error",
                            closable: false,
                          },
                        })
                      : _vm._e(),
                    _c(
                      "el-table",
                      {
                        attrs: {
                          data: group.rows,
                          size: "mini",
                          "row-key": "transNo",
                          "empty-text": _vm.t("noRows"),
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: { label: _vm.t("source"), width: "100" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-tag",
                                      { attrs: { size: "mini", type: "info" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            scope.row.source === "TICKET"
                                              ? "Ticket"
                                              : "Manual"
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: { label: _vm.t("charge"), "min-width": "300" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          scope.row.categoryName ||
                                            scope.row.categoryCode
                                        )
                                      ),
                                    ]),
                                    _c("small", [
                                      _vm._v(_vm._s(scope.row.categoryCode)),
                                    ]),
                                    scope.row.dataError
                                      ? _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              content: scope.row.dataError,
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "data-error" },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-warning",
                                                }),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(_vm.t("dataError"))
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: { label: _vm.t("ticket"), "min-width": "125" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(_vm._s(scope.row.ticketNo || "—")),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "quantity",
                            label: _vm.t("quantity"),
                            width: "100",
                            align: "right",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      _vm._s(_vm.decimal(scope.row.quantity))
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: { label: _vm.t("unit"), width: "85" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [_vm._v(_vm._s(scope.row.unit || "—"))]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: _vm.t("unitPrice"),
                            "min-width": "115",
                            align: "right",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      "$" +
                                        _vm._s(_vm.money(scope.row.unitPrice))
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: _vm.t("amount"),
                            "min-width": "130",
                            align: "right",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("strong", [
                                      _vm._v(
                                        "$" +
                                          _vm._s(
                                            _vm.money(scope.row.amountExTax)
                                          )
                                      ),
                                    ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: _vm.t("actions"),
                            width: "165",
                            align: "right",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "text",
                                          disabled: !!scope.row.dataError,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.openEdit(
                                              group,
                                              scope.row,
                                              false
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.t("editQuantity")))]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "delete-action",
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.openEdit(
                                              group,
                                              scope.row,
                                              true
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.t("delete")))]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                      ],
                      1
                    ),
                    group.lastReviewedBy || group.rows.length < group.rowTotal
                      ? _c(
                          "footer",
                          { staticClass: "group-footer" },
                          [
                            group.lastReviewedBy
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.t("lastReviewed")) +
                                      ": " +
                                      _vm._s(group.lastReviewedBy) +
                                      " · " +
                                      _vm._s(group.lastReviewedAt)
                                  ),
                                ])
                              : _vm._e(),
                            group.rows.length < group.rowTotal
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      size: "mini",
                                      loading: group.loadingRows,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.loadRows(group, true)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.t("loadMore")) +
                                        " (" +
                                        _vm._s(group.rows.length) +
                                        "/" +
                                        _vm._s(group.rowTotal) +
                                        ")"
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            )
          }),
        ],
        2
      ),
      _vm.total
        ? _c("el-pagination", {
            staticClass: "review-pagination",
            attrs: {
              background: "",
              layout: "total, prev, pager, next",
              "current-page": _vm.page,
              "page-size": 20,
              total: _vm.total,
            },
            on: { "current-change": _vm.changePage },
          })
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.edit.visible,
            title: _vm.t(_vm.edit.deleting ? "deleteTitle" : "editTitle"),
            width: "540px",
            "close-on-click-modal": false,
            "close-on-press-escape": !_vm.saving,
            "show-close": !_vm.saving,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.edit, "visible", $event)
            },
          },
        },
        [
          _vm.edit.row
            ? [
                _c("p", { staticClass: "dialog-context" }, [
                  _vm._v(
                    "Invoice " +
                      _vm._s(_vm.edit.invoiceId) +
                      " · " +
                      _vm._s(
                        _vm.edit.row.categoryName || _vm.edit.row.categoryCode
                      )
                  ),
                ]),
                _vm.edit.deleting
                  ? _c("el-alert", {
                      attrs: {
                        title: _vm.t("deleteWarning"),
                        type: "warning",
                        closable: false,
                        "show-icon": "",
                      },
                    })
                  : _vm._e(),
                _c(
                  "el-form",
                  {
                    staticClass: "edit-form",
                    attrs: { "label-position": "top" },
                    nativeOn: {
                      submit: function ($event) {
                        $event.preventDefault()
                        return _vm.saveEdit.apply(null, arguments)
                      },
                    },
                  },
                  [
                    !_vm.edit.deleting
                      ? _c(
                          "div",
                          { staticClass: "quantity-fields" },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: _vm.t("quantity") } },
                              [
                                _c("el-input", {
                                  attrs: {
                                    inputmode: "decimal",
                                    disabled: _vm.saving,
                                  },
                                  on: { input: _vm.invalidateQuote },
                                  model: {
                                    value: _vm.edit.quantity,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.edit, "quantity", $$v)
                                    },
                                    expression: "edit.quantity",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              { attrs: { label: _vm.t("savedPrice") } },
                              [
                                _c("div", { staticClass: "fixed-price" }, [
                                  _vm._v(
                                    "$" +
                                      _vm._s(
                                        _vm.money(_vm.edit.row.unitPrice)
                                      ) +
                                      " / " +
                                      _vm._s(_vm.edit.row.unit || "—") +
                                      " "
                                  ),
                                  _c("i", { staticClass: "el-icon-lock" }),
                                ]),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    !_vm.edit.deleting
                      ? _c(
                          "div",
                          { staticClass: "quote" },
                          [
                            _c("span", [_vm._v(_vm._s(_vm.t("amount")))]),
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  _vm.edit.quote
                                    ? "$" +
                                        _vm.money(_vm.edit.quote.amountExTax)
                                    : "—"
                                )
                              ),
                            ]),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  size: "small",
                                  loading: _vm.quoting,
                                  disabled: _vm.saving || !_vm.edit.quantity,
                                },
                                on: { click: _vm.quote },
                              },
                              [_vm._v(_vm._s(_vm.t("calculate")))]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.t("reason"), required: "" } },
                      [
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            rows: 3,
                            maxlength: "1000",
                            "show-word-limit": "",
                            disabled: _vm.saving,
                            placeholder: _vm.t("reasonHint"),
                          },
                          on: {
                            input: function ($event) {
                              _vm.edit.requestId = null
                            },
                          },
                          model: {
                            value: _vm.edit.reason,
                            callback: function ($$v) {
                              _vm.$set(_vm.edit, "reason", $$v)
                            },
                            expression: "edit.reason",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm.edit.error
                  ? _c("el-alert", {
                      attrs: {
                        title: _vm.edit.error,
                        type: "error",
                        closable: false,
                        "show-icon": "",
                      },
                    })
                  : _vm._e(),
                _vm.edit.conflict
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: { click: _vm.reloadEdit },
                      },
                      [_vm._v(_vm._s(_vm.t("reloadCompare")))]
                    )
                  : _vm._e(),
              ]
            : _vm._e(),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { disabled: _vm.saving },
                  on: {
                    click: function ($event) {
                      _vm.edit.visible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.t("cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: _vm.edit.deleting ? "danger" : "primary",
                    loading: _vm.saving,
                    disabled: !_vm.canSave,
                  },
                  on: { click: _vm.saveEdit },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.t(_vm.edit.deleting ? "confirmDelete" : "saveRefresh")
                    )
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.history.visible,
            title: _vm.t("history") + " · Invoice " + _vm.history.invoiceId,
            size: "760px",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.history, "visible", $event)
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.history.loading,
                  expression: "history.loading",
                },
              ],
              staticClass: "history-body",
            },
            [
              _vm.history.error
                ? _c("el-alert", {
                    attrs: {
                      title: _vm.history.error,
                      type: "error",
                      closable: false,
                    },
                  })
                : _vm._e(),
              _c(
                "el-collapse",
                _vm._l(_vm.history.rows, function (entry) {
                  return _c(
                    "el-collapse-item",
                    {
                      key: String(entry.id),
                      attrs: { name: String(entry.id) },
                    },
                    [
                      _c("template", { slot: "title" }, [
                        _c("span", [
                          _vm._v(
                            _vm._s(entry.method) +
                              " · " +
                              _vm._s(entry.createdBy) +
                              " · " +
                              _vm._s(entry.gmtCreate)
                          ),
                        ]),
                      ]),
                      _c("p", [_vm._v(_vm._s(entry.description))]),
                      _c("operation-log-detail", {
                        attrs: {
                          content: entry.content || entry.legacyContent,
                        },
                      }),
                    ],
                    2
                  )
                }),
                1
              ),
              !_vm.history.loading && !_vm.history.rows.length
                ? _c("p", [_vm._v(_vm._s(_vm.t("noHistory")))])
                : _vm._e(),
              _vm.history.total
                ? _c("el-pagination", {
                    attrs: {
                      layout: "prev, pager, next",
                      "current-page": _vm.history.page,
                      "page-size": 50,
                      total: _vm.history.total,
                    },
                    on: { "current-change": _vm.loadHistory },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }